module.exports = __webpack_public_path__ + "img/noises-27.d6d1ba41.jpg";